import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/**
 * External dependencies
 */
import React from 'react';
/**
 * Localize a React component
 *
 * @param {object} i18n I18N instance to use for localization
 * @returns {Function} Component localization function
 */

export default function (i18n) {
  var i18nProps = {
    numberFormat: i18n.numberFormat.bind(i18n),
    translate: i18n.translate.bind(i18n)
  };
  /**
   * Localize a React component
   *
   * @param  {React.Component} ComposedComponent React component to localize
   * @returns {React.Component}                   The localized component
   */

  return function (ComposedComponent) {
    var _class, _temp;

    var componentName = ComposedComponent.displayName || ComposedComponent.name || '';
    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "boundForceUpdate", _this.forceUpdate.bind(_assertThisInitialized(_this)));

        return _this;
      }

      _createClass(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          i18n.on('change', this.boundForceUpdate);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          i18n.off('change', this.boundForceUpdate);
        }
      }, {
        key: "render",
        value: function render() {
          var props = _objectSpread({
            locale: i18n.getLocaleSlug()
          }, this.props, {}, i18nProps);

          return React.createElement(ComposedComponent, props);
        }
      }]);

      return _class;
    }(React.Component), _defineProperty(_class, "displayName", 'Localized(' + componentName + ')'), _temp;
  };
}